import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { selectedFacilityOptionsImprove, timeFameListRAPIDiTrending } from 'src/app/appWeb/shared/shared';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { StrokeQualityMetricervice } from 'src/app/appServices/ControlServices/stroke-quality-metrics';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { spokeSiteOpions } from 'src/app/appWeb/shared/shared';
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
const AUTH_API = environment.teleUrl;

@Component({
  selector: 'app-rapidi-trending',
  templateUrl: './rapidi-trending.component.html',
  styleUrls: ['./rapidi-trending.component.scss']
})
export class RapidiTrendingComponent implements OnInit {
totalRecords = 0;
  pageNumber = 1;
  rows = 15;
  sortOrder = 'DESC';
  sortCol = '';
  filterVal = '';
  FileSaver = FileSaver;
  cols: any;

  showProgressSpinner: boolean = false;
  filterTypeErrorBool!: boolean;
  selectedFacilityOptions = selectedFacilityOptionsImprove;
  selectedFilterType: any;
  filterTypeBool: boolean = false;
  facilityQPSLbl: any;
  facilityErrorBool!: boolean;
  SelectListFilter: any = [];
  selectFacilityPIOptions: any;
  spokeSiteOpions = spokeSiteOpions;
  spokeSiteBool: boolean = false;
  spokeSite: any = '';
  event: any = '';
  SelectFacilityData: any = [];
  SelectSystemData: any = [];
  SelectRegionData: any = [];
  private subscription: Subscription[] = [];
  DateErrorBool : boolean = false;
  selectedDate: any = '';
  SearchLoader: boolean = false;

  timeFameList = timeFameListRAPIDiTrending;
  timeFrame = 'Last48Hours';
  showDateBool: boolean = false;
  specificDatecolorBool:boolean = false;
  dateRangeBool: boolean = false;
  txtSpecificDate: any = '';
  showStartEndDateBool: boolean = false;
  textStrtColorBool:boolean = false;
  txtStartDate: any = '';
  txtEndDate: any = '';
  minDate = new Date();
  textEndColorBool:boolean = false;

  UId: any;
  RoleName: any;
  roleForFacility: boolean = false;
  txtSpecificDateErrorBool: boolean = false;
  txtStartDateErrorBool: boolean = false;
  txtEndDateErrorBool: boolean = false;
  data = {};
  strokeQualityMetricsData: any = [];
  exportExcelLoader: boolean = false;
  datePipe = new DatePipe('en-US');
  dataForExcelBool: boolean = false;
  crossSearchBool: boolean = false;
  activationCount:any;
  assementStartCount:any;
  thrombolyticDecisionCount:any;
  thrombolyticAdministrationCount:any;
  caseList: any[] = [];
  showCaseListPopup: boolean = false;
  teleUrl: string = environment.teleUrl;

  constructor(private analyzeService: AnalyzeService,private helperService: HelperService, private authService: AuthService,
    private messageService: MessageService, private strokeQualityMetricervice: StrokeQualityMetricervice,
  private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    this.minDate = this.analyzeService.CalanderDateRangeSelection(true);
  }

  onChangeFilterType(event: any) {
    this.event = event.value;
    if (event.value == this.selectedFacilityOptions[0].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectFacilityData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 1;
      this.filterTypeBool = true;
      this.spokeSiteBool = false;
    }
    if (event.value == this.selectedFacilityOptions[1].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectSystemData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 2;
      this.filterTypeBool = true;
      this.spokeSiteBool = true;
    }
    if (event.value == this.selectedFacilityOptions[2].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectRegionData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 3;
      this.filterTypeBool = true;
      this.spokeSiteBool = true;
    }
  }

  onChangeTimeFrame(event: any) {
    if (event.value == this.timeFameList[14].value) {
      this.showStartEndDateBool = true;
    } else {
      this.showStartEndDateBool = false;
    }
    if (event.value == this.timeFameList[13].value) {
      this.showDateBool = true;
    } else {
      this.showDateBool = false;
    }
  }


  GetAllData(req: any) {
    if ((this.SelectFacilityData.length == 0 && req == 'facility') || 
    (this.SelectSystemData.length == 0 && req == 'system') ||
    (this.SelectRegionData.length == 0 && req == 'regional')) {
      // this.showProgressSpinner = true;
      let obj: any = {};
      if (req == 'facility') {
        obj.fieldName = 'facility';
        obj.value = 'facility';
      } else if(req == 'system') {
        obj.fieldName = 'ucd_ucl_key';
        obj.value = '42';
      }else{
        obj.fieldName = 'ucd_ucl_key';
        obj.value = '43';
    }
      this.subscription.push(
        this.analyzeService.GetAllData(obj, this.RoleName, this.UId).subscribe({
          next: (res: any) => {
            if (res) {
              // this.showProgressSpinner = false;
              if (req == 'facility') {
                this.SelectFacilityData = res.data;
                this.SelectListFilter = res.data;
              } else if(req == 'system') {
                this.SelectSystemData = res.data;
                this.SelectListFilter = res.data;
              }else{
                this.SelectRegionData = res.data;
                this.SelectListFilter = res.data;
              }
            }
          },
          error: (err: any) => { },
        })
      );
    }
  }

  checkEmptyFields(type:string) {
      if(this.timeFrame === '-1'){
        this.txtEndDate = new Date().toDateString();
        this.txtStartDate = this.analyzeService.CalanderDateRangeSelection(true).toDateString();
      }
      this.data = {
        Take: type == 'grid' ? this.rows : 0,
        Skip: type == 'grid' ? this.rows * this.pageNumber - this.rows : 0,
        Sort: {
          FieldName: this.sortCol,
          Order: this.sortOrder,
        },
        // searchString: this.searchField.trim(),
        PageNumber: this.pageNumber,
        serviceType: [],
        roleIDs: [''],
        Filters: [

          {
            FieldName: 'date_filter',
            value: this.timeFrame  == '-1' ? 'DateRange' : this.timeFrame
          },
          {
            FieldName: 'specific_date',
            value: this.txtSpecificDate,
          },
          {
            FieldName: 'start_date',
            value: this.txtStartDate,
          },
          {
            FieldName: 'end_date',
            value: this.txtEndDate,
          },
        ],
        data: {
          Facilities: this.selectedFilterType == 'facility' ? [this.selectFacilityPIOptions]: [],
          System: this.selectedFilterType == 'system' ? [this.selectFacilityPIOptions]: [],
          Regional: this.selectedFilterType == 'regional' ? [this.selectFacilityPIOptions]: [],
          FilterType: this.selectedFilterType,
          SpokeSiteFilter: this.spokeSite
        }
      };
      if(type == 'grid'){
      if(this.timeFrame == "DateRange"){
        if(this.txtStartDate == null || this.txtStartDate == ''){
          this.txtStartDateErrorBool = true;
        }else{
          this.txtStartDateErrorBool = false;
        }
        if(this.txtEndDate == null || this.txtEndDate == ''){
          this.txtEndDateErrorBool = true;
        }else{
          this.txtEndDateErrorBool = false;
        }
        if(this.txtStartDate != null && this.txtEndDate != null && this.txtEndDate !== '' && this.txtStartDate !== ''){
          let txtStartDate = new Date(this.txtStartDate);
          let txtEndDate = new Date(this.txtEndDate);
          if(txtStartDate > txtEndDate){
            this.dateRangeBool = true;
          }else{
            this.dateRangeBool = false;
          }
        }
      }else{
        this.txtStartDateErrorBool = false;
        this.txtEndDateErrorBool = false;
        this.dateRangeBool = false;
      } 
      
      if(this.timeFrame == "SpecificDate"){
        if(this.txtSpecificDate == null || this.txtSpecificDate == ''){
          this.txtSpecificDateErrorBool = true;
        }else{
          this.txtSpecificDateErrorBool = false;
        }
      }else{
        this.txtSpecificDateErrorBool = false;
      }
    }
    
  }

  GetStrokeQualityMetricsData(type:string){
   this.checkEmptyFields('grid');

    if (this.selectedFilterType != null && this.selectFacilityPIOptions != null && this.timeFrame !== 'SpecificDate' && this.timeFrame !== 'DateRange' ||
    this.selectedFilterType != null && this.selectFacilityPIOptions != null && this.timeFrame == 'SpecificDate' && this.txtSpecificDateErrorBool == false ||
    this.selectedFilterType != null && this.selectFacilityPIOptions != null && this.timeFrame == 'DateRange' && this.txtStartDateErrorBool == false && this.txtEndDateErrorBool == false && 
    this.dateRangeBool == false) {
    this.showProgressSpinner = true;
    this.clearAllTrees();
    this.loadFishBoneDiagram();
    }else{
      if (this.selectedFilterType == null && type === 'click') {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Plese select Filter Type first.',
        });
        this.filterTypeErrorBool = true;
        setTimeout(() => {
          this.filterTypeErrorBool = false;
        }, 1000);
        return;
      }

      if (this.selectFacilityPIOptions == null && type === 'click') {
        let facilitysystem: any;
        if (this.event == 'facility') {
          facilitysystem = 'Facility';
        } else if(this.event == 'system')  {
          facilitysystem = 'System';
        } else  {
          facilitysystem = 'Regional';
        }
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: `Plese select ${facilitysystem} first.`,
        });
        this.facilityErrorBool = true;
        setTimeout(() => {
          this.facilityErrorBool = false;
        }, 1000);
        return;
      }

      if (this.selectFacilityPIOptions == null && type === 'click') {
        let monthquarter: any;
        if (this.event == 'facility') {
          monthquarter = 'Month'
        } else {
          monthquarter = 'Quarter'
        }
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: `Plese select ${monthquarter} first.`,
        });
        this.facilityErrorBool = true;
        setTimeout(() => {
          this.facilityErrorBool = false;
        }, 1000);
        return;
      }
      if(this.txtSpecificDateErrorBool == true && type === 'click'){
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select Date first.',
        });
        this.specificDatecolorBool = true;
        setTimeout(() => {
        this.specificDatecolorBool = false;
        }, 1000);
        return;
      }
      if(this.txtStartDateErrorBool == true && type === 'click'){
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select Start Date first.',
        });
        this.textStrtColorBool = true;
        setTimeout(() => {
        this.textStrtColorBool = false;
        }, 1000);
        return;
      }
      if(this.txtEndDateErrorBool == true && type === 'click'){
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select End Date first.',
        });
        this.textEndColorBool = true;
        setTimeout(() => {
        this.textEndColorBool = false;
        }, 1000);
        return;
      }
      if(this.dateRangeBool == true && type === 'click'){
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'End Date should be greater than Start Date.',
        });
        // this.textStrtColorBool = true;
        this.textEndColorBool = true;
        setTimeout(() => {
          // this.textStrtColorBool = false;
          this.textEndColorBool = false;
        }, 1000);
        return;
      }
    }
  }


  //#region Fish Bone Diagram
  
  async loadFishBoneDiagram() {
    await this.showRCAFishBoneDiagram('activation', 'RCAFishBoneJSTreeforActivation');
    await this.showRCAFishBoneDiagram('assessment_start_time', 'RCAFishBoneJSTreeforAssessment');
    await this.showRCAFishBoneDiagram('thrombolytic_decision', 'RCAFishBoneJSTreeforTD');
    await this.showRCAFishBoneDiagram('thrombolytic_administration', 'RCAFishBoneJSTreeforTA');
    this.showProgressSpinner = false;
  }
  
  showRCAFishBoneDiagram( RcaDiagramOption: any, fishBoneId: any ): Promise<void> {

    return new Promise((resolve, reject) => {
      this.subscription.push(
        this.strokeQualityMetricervice
          .GetFishBoneDiagramValues(this.UId, this.RoleName, RcaDiagramOption, this.data)
          .subscribe({
            next: (res: any) => {
              if(res.Data && res.Data.length > 0){
                this.RCAFishBoneFileTree(res.Data, fishBoneId);
              }
              switch (fishBoneId) {
                case fishBoneId = 'RCAFishBoneJSTreeforActivation':
                  this.activationCount = res.TotalCount;
                  break;
                case fishBoneId = 'RCAFishBoneJSTreeforAssessment':
                  this.assementStartCount = res.TotalCount;
                  break;
                case fishBoneId = 'RCAFishBoneJSTreeforTD':
                  this.thrombolyticDecisionCount = res.TotalCount;
                  break;
                case fishBoneId = 'RCAFishBoneJSTreeforTA':
                  this.thrombolyticAdministrationCount = res.TotalCount;
                  break;
              }
              resolve();
            },
            error: (err: any) => {
              reject();
            },
          })
      );
    });
  }
  
  RCAFishBoneFileTree(FileTreeValues: any, fishBoneId: any) {
    // Destroy previous tree and handlers
    const $tree = $('#' + fishBoneId);
    $tree.jstree('destroy').empty();
    $tree.off();
  
    // Initialize JSTree
    $tree.jstree({
      core: {
        data: FileTreeValues,
        themes: {
          icons: false,
        }
      },
      checkbox: {
        three_state: false,
        cascade: 'none'
      },
      plugins: ['themes', 'wholerow', 'checkbox']
    })
    .one('ready.jstree', function () {
      $tree.off('dblclick.jstree')
           .on('dblclick.jstree', '.jstree-anchor', function (e) {
             e.preventDefault();
             e.stopImmediatePropagation();
             return false;
           });
    });
  
    // Handle click on badge span
    $tree.on('click', '.case-count-badge', (event) => {
      event.preventDefault();
      event.stopPropagation();
    
      const $target = $(event.currentTarget);
      const allCases = $target.data('cases');
      const allkeys = $target.data('keys');
      this.showCaseNumbersPopup(allCases, allkeys);
    });
  
    // Show the tree
    $tree.show();
    this.cdr.detectChanges();
  }

  
  clearAllTrees() {
    $('[id^="RCAFishBoneJSTree"]').each(function () {
      const treeRef = $(this);
      try {
          treeRef?.jstree('destroy').empty();
          treeRef?.empty();
      } catch (e) {
        treeRef?.empty();
      }
    });

    this.activationCount = undefined;
    this.assementStartCount = undefined;
    this.thrombolyticDecisionCount = undefined;
    this.thrombolyticAdministrationCount = undefined;
        
  }

  //#region case no popup

  showCaseNumbersPopup(cases: any, keys: any) {
    this.showCaseListPopup = true;
  
    let caseArray: string[] = [];
    let keysArray: string[] = [];
  
    if (typeof cases === 'number') {
      caseArray = [cases.toString()];
    } else if (typeof cases === 'string') {
      caseArray = cases.split(',').map(x => x.trim());
    }
  
    if (typeof keys === 'number') {
      keysArray = [keys.toString()];
    } else if (typeof keys === 'string') {
      keysArray = keys.split(',').map(x => x.trim());
    }
  
    // Combine into array of objects
    this.caseList = caseArray.map((c, i) => ({
      caseNumber: c,
      keysNumber: keysArray[i] || ''
    }));
  }
  
  closeCaseListPopup(){
    this.showCaseListPopup = false;
    this.caseList = [];
  }

  Accesscase(cas: any) {
    let accessCase:any;
    if (cas) {
      accessCase =
        this.teleUrl + `Case/Edit/${Number(cas)}?showPopupOnLoad=true`;
      window.open(accessCase);
    } 
  }

}
